import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SettingsModule } from '../settings/settings.module';
import { SharedAnonymousModule } from './shared.anonymous.module';
import { TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { IuiModalWindowModule } from '@itero/ui-components-angular/modal-window';
import { IuiSelectComponent } from '@itero/ui-components-angular/select';
import { IuiCheckboxComponent } from '@itero/ui-components-angular/checkbox';
import { IuiButtonComponent } from '@itero/ui-components-angular/button';
import { TrimPipe } from './trim.pipe';
import { EupDatePipe } from './eupDate.pipe';
import { ReceivedDatePipe } from './receivedDate.pipe';
import { EupDefaultText } from './eupDefaultText.pipe';
import { OrderByPipe } from './orderBy.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { TableComponent } from './table/table.component';
import { SortableHeaderColumn } from './sortableHeaderColumn/sortableHeaderColumn.component';
import { DownloadLinkModal } from './downloadLinkModal/downloadLinkModal.component';
import { ChangeCaseTypeModal } from './changeCaseType/changeCaseType.component';
import { ChangeCaseTypeService } from './changeCaseType/changeCaseType.service';
import { ClickOutsideDirective } from './clickOutside.directive';
import { StickyHeaderComponent } from './stickyHeader/stickyHeader.component';
import { LabStickyHeaderComponent } from './labStickyHeader/labStickyHeader.component';
import { MobileStickyHeaderComponent } from './stickyHeader/mobile-sticky-header/mobile-sticky-header.component';
import { OrthoCadExportModal } from './orthoCadExport/orthoCadExport.component';
import { RestorativeExportModal } from './restorativeExport/restorativeExport.component';
import { TableFocusElementDirective } from './tableFocusElement.directive';
import { ShowButtonsRowDirective } from './showButtonsRow.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AccessibilityService } from './accessibility.service';
import { DownloadNotificationComponent } from './downloadNotification/downloadNotification.component';
import { ExportDownloadsProgressListComponent } from './exportDownloadsProgressList/exportDownloadsProgressList.component';
import { HighlightTextPipe } from './highlightText.pipe';
import { DieOrdersComponent } from './dieOrders/dieOrders.component';
import { IteroNoteComponent } from './iteroNote/iteroNote.component';
import { IteroOrdersNotesComponent } from './iteroOrdersNotes/iteroOrdersNotes.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LabExportModal } from './labExport/labExport.component';
import { WindowsAppButtonComponent } from './windowsAppButton/windowsAppButton.component';
import { PatientAppService } from './PatientApp/patientApp.service';
import { PatientAppModalComponent } from './PatientApp/patientAppModal/patientApp.component';
import { TimerDirective } from './timer/timer.directive';
import { InactivityTimerDirective } from './inactivity-timer/inactivity-timer.directive';
import { ActivityMonitorDirective } from './inactivity-timer/activity-monitor.directive';
import { FeaturesToggleDirective } from '../featuresToggleSettings/directive/featuresToggle.directive';
import { GenericUIModule } from '@shared/genericUI/module/generic-ui/generic-ui.module';
import { IOSimPlusButtonComponent } from './iosim-plus/iosim-plus-button/iosim-plus-button.component';
import { AllowedCaseTypesDirective } from './allowedCaseTypes.directive';
import { VisitReportComponent } from 'app/visit-report/visit-report.component';
import { AccountManagementService } from '../practiceManagement/services/account-management.service';
import { SafeUrlPipe } from './safeUrl.pipe';
import { ReferralMaskDirective } from './referralMask/referral.mask.directive';
import { StatusInfoModalComponent } from '@shared/iosim-plus/iosim-plus-button/status-info-modal/status-info-modal.component';
import { StatusInfoModalDialogComponent } from '@shared/iosim-plus/iosim-plus-button/status-info-modal/status-info-modal-dialog/status-info-modal-dialog.component';
import { TernaryPipe } from './ternary.pipe';
import { MapperPipe } from './mapper.pipe';
import { PrintRxAppComponent } from 'app/rx/print-rx/print-rx-app.component';
import { DateOfBirthPipe } from '@shared/date-of-birth.pipe';
import { PracticeInformationBlockComponent } from 'app/practiceManagement/components/info/practice-information-block/practice-information-block.component';
import { CheckOverflowComponent } from '@shared/check-overflow.component';
import { ExocadMiniAppModal } from './exocadMiniAppModal/exocadMiniAppModal.component';
import { NotificationCardComponent } from 'app/notification-card/notification-card.component';
import { ScreenshotManagerComponent } from './screenshot-manager/screenshot-manager.component';
import { ScreenShotComponent } from 'app/doctors/iosimPlus/components/screen-shot/screen-shot.component';
import { DrawingToolComponent } from 'app/doctors/iosimPlus/components/drawing-tool/drawing-tool.component';
import { ExocadMiniAppModalService } from './exocadMiniAppModal/exocadMiniAppModal.service';
import { ShowAllToggleComponent } from './show-all-toggle/show-all-toggle.component';
import { AssignToMeButtonComponent } from './referralOrders/assign-to-me-button/assign-to-me-button.component';
import { EmbeddedRemoteApplicationComponent } from '@itero/standard-launch-sdk';

const standalonePipes = [
	TrimPipe,
	EupDatePipe,
	SafeHtmlPipe,
];

const sharedComponents = [
	OrderByPipe,
	TableComponent,
	SortableHeaderColumn,
	DownloadLinkModal,
	LabExportModal,
	EupDefaultText,
	ReceivedDatePipe,
	ChangeCaseTypeModal,
	TableFocusElementDirective,
	ShowButtonsRowDirective,
	OrthoCadExportModal,
	ClickOutsideDirective,
	StickyHeaderComponent,
	LabStickyHeaderComponent,
	MobileStickyHeaderComponent,
	DieOrdersComponent,
	RestorativeExportModal,
	ExocadMiniAppModal,
	DownloadNotificationComponent,
	ExportDownloadsProgressListComponent,
	HighlightTextPipe,
	IteroNoteComponent,
	IteroOrdersNotesComponent,
	LabExportModal,
	WindowsAppButtonComponent,
	TimerDirective,
	InactivityTimerDirective,
	ActivityMonitorDirective,
	PatientAppModalComponent,
	FeaturesToggleDirective,
	IOSimPlusButtonComponent,
	AllowedCaseTypesDirective,
	VisitReportComponent,
	SafeUrlPipe,
	ReferralMaskDirective,
	StatusInfoModalComponent,
	TernaryPipe,
	MapperPipe,
	PrintRxAppComponent,
	DateOfBirthPipe,
	PracticeInformationBlockComponent,
	CheckOverflowComponent,
	NotificationCardComponent,
	DrawingToolComponent,
	ScreenShotComponent,
	ScreenshotManagerComponent,
	AssignToMeButtonComponent
];

@NgModule({
    imports: [
		SharedAnonymousModule,
		SettingsModule,
		InfiniteScrollModule,
		FontAwesomeModule,
		GenericUIModule,
		ShowAllToggleComponent,
		EmbeddedRemoteApplicationComponent,
		TlkModalWindowModule,
		IuiModalWindowModule,
		IuiSelectComponent,
		IuiCheckboxComponent,
		IuiButtonComponent,
		StatusInfoModalDialogComponent,
		...standalonePipes
	],
	declarations: [...sharedComponents],
	exports: [SharedAnonymousModule, GenericUIModule, ...sharedComponents, ...standalonePipes, SettingsModule, ShowAllToggleComponent],
	providers: [
		ChangeCaseTypeService,
		AccessibilityService,
		PatientAppService,
		AccountManagementService,
		EupDatePipe,
		TernaryPipe,
		MapperPipe,
		ExocadMiniAppModalService,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
